"use strict";
exports.__esModule = true;
var react_1 = require("react");
var loadjs = require("loadjs");
var useGoogleAPI = function () {
    var APIKEY = process.env.GOOGLEAPI;
    var APIURL = 'https://maps.googleapis.com/maps/api/js?libraries=geometry';
    var SCRIPTNAME = 'googlemapApiScript';
    var googleMapScriptUri = APIURL + "&key=" + APIKEY;
    var _a = react_1.useState(false), apiLoaded = _a[0], setApiLoaded = _a[1];
    react_1.useEffect(function () {
        if (typeof document === 'undefined')
            return;
        if (!loadjs.isDefined(SCRIPTNAME)) {
            loadjs(googleMapScriptUri, SCRIPTNAME);
        }
        loadjs.ready(SCRIPTNAME, {
            success: function () {
                return setApiLoaded(true);
            },
            error: function () {
                loadjs.reset();
                console.log('Failed to load Google Map Script');
            }
        });
    });
    return apiLoaded;
};
exports.useGoogleAPI = useGoogleAPI;
